import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminMeterSolar(props) {
    const formmeterRef = useRef(null)

    const [plantlist, setPlantlist] = useState([]);
    const [meterlist, setMeterlist] = useState([]);
    const [meteritem, setMeteritem] = useState({
        id: 0,
        ipaddress: '',
        modbus_id: 0,
        solar_type: '',
        measure_side: 'LV',
        cod_acc: 0,
        ct_ref: '',
        serial_no: ''
    });
    const [mode, setMode] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_meter, setModal_meter] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
        api_delete_data()
    }

    useEffect(() => {
        api_get_list()
        return () => {
            setPlantlist([]);
            setMeterlist([]);
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading solar meter list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/solarmeter/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setMeterlist(response.data.meter)
                    if (response.data.plantlist !== null) {
                        setPlantlist(response.data.plantlist)
                    } else {
                        setPlantlist([])
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    function manageMeter(mode, selectdata) {
        if (mode === 'add') {
            setMode('add')
            setMeteritem({
                id: 0,
                ipaddress: '',
                modbus_id: 0,
                solar_type: '',
                measure_side: 'LV',
                cod_acc: 0,
                ct_ref: '',
                serial_no: ''
            })
            setModal_meter(true)
        }
        else if (mode === 'edit') {
            setMode('edit')
            setMeteritem(selectdata)
            setModal_meter(true)
        }
        else if (mode === 'delete') {
            setMeteritem(selectdata)
            setModal_popup({
                modaltype: 'modal-confirm',
                headers: 'Confirmation',
                message: "Please click on confirm button to continue this operation.",
                enable: true
            });
        }
    }

    async function api_save_data() {
        var formelement = formmeterRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('id', meteritem.id)
            formData.append('ipaddress', meteritem.ipaddress)
            formData.append('modbus_id', meteritem.modbus_id)
            formData.append('solar_type', meteritem.solar_type)
            formData.append('measure_side', meteritem.measure_side)
            formData.append('cod_acc', meteritem.cod_acc)
            formData.append('ct_ref', meteritem.ct_ref)
            formData.append('serial_no', meteritem.serial_no)

            setmodal_load({ enable: true, message: "Saving solar meter." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/solarmeter/" + mode, formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_meter(false)
                    setMeteritem({
                        id: 0,
                        ipaddress: '',
                        modbus_id: 0,
                        solar_type: '',
                        measure_side: 'LV',
                        cod_acc: 0,
                        ct_ref: '',
                        serial_no: ''
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your solar meter has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.meter !== undefined) {
                        setMeterlist(response.data.meter)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_meter(false)
                    setMeteritem({
                        id: 0,
                        ipaddress: '',
                        modbus_id: 0,
                        solar_type: '',
                        measure_side: 'LV',
                        cod_acc: 0,
                        ct_ref: '',
                        serial_no: ''
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_delete_data() {
        setmodal_load({ enable: true, message: "Deleting solar meter." })
        await sleep(500)

        const formData = new FormData();
        formData.append('id', meteritem.id)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/solarmeter/delete", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                setMeteritem({
                    id: 0,
                    ipaddress: '',
                    modbus_id: 0,
                    solar_type: '',
                    measure_side: 'LV',
                    cod_acc: 0,
                    ct_ref: '',
                    serial_no: ''
                })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your solar meter has been deleted fron database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.meter !== undefined) {
                    setMeterlist(response.data.meter)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setMeteritem({
                    id: 0,
                    ipaddress: '',
                    modbus_id: 0,
                    solar_type: '',
                    measure_side: 'LV',
                    cod_acc: 0,
                    ct_ref: '',
                    serial_no: ''
                })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-tachometer-alt"></i> Solar Meter</h4>
                                    <p className="mb-3">Manage all solar meters</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Solar Meter Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th className="id-fixwidth">No.</th>
                                        <th>Meter ID</th>
                                        <th>IP Address</th>
                                        <th>Modbus ID</th>
                                        <th>Serial No.</th>
                                        <th>Solar Type</th>
                                        <th>Measure Side</th>
                                        <th>CT Ratio Ref.</th>
                                        <th>COD Acc.</th>
                                        <th>Edit Time</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        meterlist?.map((meter, index) => (
                                            <tr key={meter.id}>
                                                <td><i className="fas fa-tachometer-alt rows-icon"></i> {index + 1}</td>
                                                <td>{meter.id}</td>
                                                <td>{meter.ipaddress}</td>
                                                <td>{meter.modbus_id}</td>
                                                <td>{meter.serial_no}</td>
                                                <td>{meter.solar_type}</td>
                                                <td>{meter.measure_side === "HV" ? "High Voltage" : meter.measure_side === "LV" ? "Low Voltage" : "Unknown"}</td>
                                                <td>{meter.ct_ref}</td>
                                                <td>{meter.cod_acc}</td>
                                                <td>{moment(new Date(meter.edittime)).format('YYYY-MMM-DD HH:mm:ss')}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-success btn-hover btn-bordered" title="Edit" onClick={() => { manageMeter('edit', meter) }}><i className="fas fa-pen"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_meter ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-tachometer-alt"></i> {mode === "add" ? "Add" : "Edit"} Solar Meter</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_meter(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formmeterRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="meter_id">Meter ID</label>
                                                                <input type="number" className="form-control" name="meter_id" min={1} max={3} value={meteritem.id} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        id: e.target.value
                                                                    })
                                                                }} required disabled={mode === "edit"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="ipaddress">IP Address (IPV4)</label>
                                                                <input type="text" className="form-control" name="ipaddress" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" value={meteritem.ipaddress} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        ipaddress: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="modbus_id">Modbus ID</label>
                                                                <input type="number" className="form-control" name="modbus_id" min={1} max={256} value={meteritem.modbus_id} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        modbus_id: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="cod_acc">Meter COD Acc.</label>
                                                                <input type="number" className="form-control" name="cod_acc" value={meteritem.cod_acc} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        cod_acc: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label htmlFor="solar_type">Solar Type</label>
                                                            <select name="solar_type" className="form-select mb-3" value={meteritem.solar_type} onChange={(e) => {
                                                                setMeteritem({
                                                                    ...meteritem,
                                                                    solar_type: e.target.value
                                                                })
                                                            }} required>
                                                                <option value="">Select solar type</option>
                                                                {
                                                                    plantlist.map((plantx, index) => (
                                                                        <option value={plantx} key={"plant-" + plantx}>{plantx}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="measure_side">Measure Side</label>
                                                            <select name="measure_side" className="form-select mb-3" value={meteritem.measure_side} onChange={(e) => {
                                                                setMeteritem({
                                                                    ...meteritem,
                                                                    measure_side: e.target.value
                                                                })
                                                            }} required>
                                                                <option value="">Unknown</option>
                                                                <option value="LV">Low Voltage</option>
                                                                <option value="HV">High Voltage</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="ct_ref">CT Ratio Ref.</label>
                                                                <input type="text" className="form-control" name="ct_ref" value={meteritem.ct_ref} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        ct_ref: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="serial_no">Serial No.</label>
                                                                <input type="text" className="form-control" name="serial_no" value={meteritem.serial_no} onChange={(e) => {
                                                                    setMeteritem({
                                                                        ...meteritem,
                                                                        serial_no: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_meter(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminMeterSolar